import {svg, html, css, LitElement} from 'lit';
import {LightDocumentObjectModelNexusComponent} from '../modules/light-document-object-model-nexus-component.js';
import {NexusComponent} from '../modules/nexus.component.js';
import {ColorModule} from '../modules/color.module';
import {ButtonWithDropdown} from "./button-with-dropdown.component";
import * as bootstrap from 'bootstrap';

export class NexusImgComponent extends LightDocumentObjectModelNexusComponent {
    tappedAmount = 0;
    static properties = {
        ai: {
            type: String,
        },
        ai_template: {
            // .ai-big, ai-small
            type: String,
            reflect: true,
            useDefault: true,
        },
        bg: {
            type: String,
            reflect: true,
            useDefault: true,
        },
        tooltip: {
            type: String,
        },
        visibility_classes: {
            type: String,
            reflect: true,
        },
        tab_index: {
            type: Number,
            reflect: true,
            useDefault: true,
        }
    };

    timeOut = 100;
    currentTick = 0;
    interactionState = 'loading';
    hoverState = 'indeterminate';
    buttonState = '';

    constructor() {
        super();
        this.ai = null;
        this.bg = 'dark';
        this.tooltip = null;
        this.tooltipList = null;
        this.visibility_classes = '';
        this.tab_index = 0;
        this.aiButtonTabIndex = this.tab_index;
        this.ai_template = 'big';
        this.isWithinLink = false;
    }

    doUpdate() {

    }

    connectedCallback() {
        super.connectedCallback();
        if (this.renderRoot.querySelector('img')) {
            this.renderRoot.querySelector('img').addEventListener('load', (event) => {
                // so, by prefixing medium-zoom valid .on() event names with 'medium-zoom', we can just use the regular html Element: 'closed' = 'medium-zoom:closed'
                this.renderRoot.querySelector('img').addEventListener('medium-zoom:closed', (event) => {
                    // reset the tapped amount to keep showing ai label if present
                    if (
                        this.tappedAmount === 2
                    ) {
                        this.tappedAmount = 0;
                    }

                    this.requestUpdate();
                })

                setTimeout(() => {
                    this.interactionState = 'indeterminate';
                    this.requestUpdate();
                }, 1);

            })
            this.renderRoot.querySelector('img').addEventListener('progress', (event) => {
                console.log('progress!');
            })
        }
    }

    firstUpdated() {
        super.firstUpdated();

        let closestLink = this.renderRoot.closest('a.element-link');
        if (closestLink) {
            // console.log('closestLink', closestLink);
            this.isWithinLink = true;
            closestLink.tabIndex = 0;
            closestLink.addEventListener('blur', (event) => {
                this.aiButtonTabIndex = 0;
                this.requestUpdate();
            });
        }

        if (this.tooltip) {
            // only if there is a tooltip configuration from attribute tooltip, then activate bootstrap tooltip toggle. Otherwise, just not activate this component level activator
            const tooltipTriggerList = this.renderRoot.querySelectorAll('[data-bs-toggle="tooltip"]')
            this.tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
        }
        // loading
        // setTimeout(() => {
        //     this.interactionState = 'indeterminate';
        //     this.requestUpdate();
        // }, 1000);
        if (this.renderRoot.querySelector('.ai-label')) {
            let aiLabel = this.renderRoot.querySelector('.ai-label');
            if (
                this.isWithinLink === true
            ) {
                // alert(this.isWithinLink);
                aiLabel.addEventListener('focusin', (event) => {
                    this.aiButtonTabIndex = -1;
                })
            }
            aiLabel.addEventListener('click', (event) => {
                this.tappedAmount += 1;
                this.interactionState = 'clicked';
                if (this.tappedAmount >= 2) {
                    this.interactionState = 'clicked-twice';
                    this.buttonState = 'disabled';
                }
                // make it more compatible with touch stuff
                if (
                    this.tappedAmount >= 2
                    &&
                    this.tooltip && this.tooltipList
                ) {

                    this.tooltipList.forEach((tooltip) => {
                        console.log(`tooltip...`, tooltip);
                        tooltip.hide();
                    });
                }

                if (
                    this.tooltip === null
                    &&
                    this.tappedAmount >= 1
                ) {
                    this.interactionState = 'clicked-twice';
                }
                this.requestUpdate();
            });
            aiLabel.addEventListener('mouseover', (event) => {
                this.hoverState = 'mouseover';
                this.tappedAmount = 2;
                this.requestUpdate();
            });
            aiLabel.addEventListener('mouseout', (event) => {
                this.hoverState = 'indeterminate';
                this.requestUpdate();
            });
            aiLabel.addEventListener('focus', (event) => {
                this.hoverState = 'mouseover';
                this.tappedAmount = 2;
                this.requestUpdate();
            });
            aiLabel.addEventListener('blur', (event) => {
                this.hoverState = 'indeterminate';
                this.requestUpdate();
            });


        }

        if (this.renderRoot.querySelector('img')) {
            let img = this.renderRoot.querySelector('img');
            // img.tabIndex = this.tab_index;
            img.addEventListener('click', (event) => {
                if (this.tappedAmount >= 2) {
                    this.interactionState = 'clicked-twice';
                    this.buttonState = 'disabled';
                    this.requestUpdate();

                }
                this.requestUpdate();
            });
        }

        let lazyLoadedBackgroundImages = this.renderRoot.querySelectorAll('[data-bg]');
        lazyLoadedBackgroundImages.forEach((lazyLoadedBackgroundImage) => {
            console.log(`lazyLoadedBackgroundImage`, lazyLoadedBackgroundImage);
            lazyLoadedBackgroundImage.addEventListener('lazybeforeunveil', (event) => {
                this.onLazyBeforeUnveil(event);
            })
        });
    }

    onLazyBeforeUnveil(event) {
        console.log('onLazyBeforeUnveil');
        var bg = event.target.getAttribute('data-bg');
        if (bg) {
            event.target.style.backgroundImage = 'url(' + bg + ')';
            setTimeout(() => {
                this.interactionState = 'indeterminate';
                this.requestUpdate();
            }, 1);
        }
    }

    /**
     * This needs a bit of documentation:
     * as we render in the light DOM, lift will render stuff that comes out of this render method here AFTER the 'fallback'
     * (synchronously loaded text/markup as it come in through the browser connection)
     *
     * @returns {*}
     */
    render() {
        return html`
            <!-- From here, the component markup is dynamic and js based -->
            ${this.renderArtificialIntelligenceLabel(`generated`)}
        `;
    }

    //                 <div class="col-auto pe-0 align-self-center">
    //                     // <svg class="svg-icon svg-icon-hover svg-icon-size-20 static-color">
    //                     //     <use xlink:href="#icon-robot-2"></use>
    //                     //     <title>AI ${text}</title>
    //                     // </svg>
    //                 </div>

    renderArtificialIntelligenceLabel(text) {
        let template = html``;
        if (this.ai) {

            template = html`
                <button
                        tabindex="${this.aiButtonTabIndex}"
                        ?disabled=${this.facultativelyRenderButtonDisabledStateAttribute()}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="${this.tooltip}"
                        data-bs-trigger="click hover focus"
                        class="${this.visibility_classes} btn ${this.renderSmallButtonClassBasedOnAiTemplate()} btn-${this.bg} hover-state-${this.hoverState} interaction-state-${this.interactionState} bg-${this.bg} shadow-sm ai-label ai-label-${this.ai_template}"
                >
                    <div class="row">
                        <div class="col align-self-center">
                            <div class="row">
                                <div class="col col-auto ${this.renderArtificialIntelligenceLabelPaddingClass()} text-strong ai-${this.ai_template} align-self-center">
                                    AI
                                </div>
                                ${this.renderArtificialIntelligenceLabelAffix()}
                            </div>
                        </div>
                    </div>
                </button>`;

        }
        return template;
    }

    renderSmallButtonClassBasedOnAiTemplate() {
        let template = ``;
        if (this.ai_template === 'small') {
            template = `btn-sm`;
        }
        return template;
    }

    facultativelyRenderButtonDisabledStateAttribute() {
        if (this.buttonState === 'disabled') {
            return true;
        }
        return false;
    }

    renderArtificialIntelligenceLabelPaddingClass() {
        let template = `p-0 mx-auto`;
        if (this.ai && this.ai.length <= 1) {
            template = `p-0 mx-auto`;
        }
        if (this.ai && this.ai.length > 1) {
            template = `pe-0`;
        }
        return template;
    }

    renderArtificialIntelligenceLabelAffix() {
        let template = html``;
        if (this.ai && this.ai.length > 1) {
            template = html`
                <div class="col align-self-center hyphenate">
                    ${this.ai}
                </div>
            `;
        }
        return template;
    }
}

customElements.define("nexus-img", NexusImgComponent);
